module.exports = __webpack_public_path__ + "static/media/6D.ff1c6299.png";